import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { InternalConfig, ModalConfig, StoreModalConfig } from '@app/core/pcs-modal/modal-config';
import { ModalHostDirective } from '@app/core/pcs-modal/modal-host.directive';
import { RootModalComponent } from '@app/core/pcs-modal/root-modal.component';

export const DEFAULT_MODALS_FEATURE_NAME = 'modalsStore';

export function createStoreModalDefaultConfig(config: StoreModalConfig): StoreModalConfig {
  return {
    stateKey: DEFAULT_MODALS_FEATURE_NAME,
    ...config
  };
}

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: ModalConfig,
      useFactory: createStoreModalDefaultConfig,
      deps: [InternalConfig]
    }
  ],
  declarations: [
    RootModalComponent,
    ModalHostDirective
  ],
  exports: [
    RootModalComponent
  ]
})
export class PcsModalModule {
  static forRoot(config: StoreModalConfig = {}): ModuleWithProviders<PcsModalModule> {
    return {
      ngModule: PcsModalModule,
      providers: [
        {
          provide: InternalConfig,
          useValue: config
        }
      ]
    };
  }
}
